var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.083,21.578l-6.317-3.647c-0.458-0.265-1.005-0.337-1.518-0.2s-0.949,0.472-1.215,0.932L35.665,59.139 c-0.015,0.026-0.023,0.055-0.037,0.082c-0.025,0.048-0.046,0.097-0.067,0.148c-0.037,0.089-0.068,0.179-0.091,0.271 c-0.008,0.031-0.024,0.058-0.03,0.089l-2.402,11.456c-0.177,0.846,0.209,1.71,0.958,2.143c0.312,0.18,0.656,0.268,1,0.268 c0.481,0,0.958-0.174,1.334-0.51l8.72-7.809c0.012-0.011,0.02-0.025,0.031-0.036c0.046-0.043,0.083-0.094,0.125-0.142 c0.072-0.082,0.141-0.165,0.199-0.257c0.013-0.02,0.031-0.035,0.043-0.055L68.815,24.31C69.367,23.354,69.04,22.13,68.083,21.578z  M38.788,63.251l1.536,0.887l-2.12,1.898L38.788,63.251z M42.983,61.054l-1.427-0.824l-1.427-0.824l21.369-37.012l2.853,1.647 L42.983,61.054z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e4ecab878b1afb7250daba32e9080cdc.svg";
export { ForwardRef as ReactComponent };